<template>
  <v-app>
    <TopBar v-if="$route.path !== '/' && $route.name !== 'Not found'"/>
    <router-view></router-view>
    <SnackBar />

    <Loading />
    <!-- <loading-aux style="z-index: 9999"></loading-aux> -->

    <portal-target name="portal-raiz-projeto" />
    <!-- <ChatSuporte /> -->
    <ChatSuporteOctadesk />
    <Nps v-if="$route.path !== '/'" />
  </v-app>
</template>

<script>
import TopBar from "@/components/layout/TopBar";
import SnackBar from "@/components/utils/SnackBar";
import Loading from "@/components/utils/Loading";
import LoadingAux from "@/components/utils/loadingAux";
// import ChatSuporte from "@/ChatSuporte.vue";
import ChatSuporteOctadesk from "@/ChatSuporteOctadesk.vue";
import Nps from "@/components/Nps.vue";

export default {
  components: {
    TopBar,
    SnackBar,
    Loading,
    LoadingAux,
    // ChatSuporte,
    ChatSuporteOctadesk,
    Nps,
  },
};
</script>
